/**
 * profile-photo.js
 */

import React from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { UserContext } from 'contexts/user/user-context';
import Button from 'components/button';
import PhotoEditor from 'components/photo-editor';
import DrawerContentBuilder from 'components/menu-drawer/drawer-content-builder';
import DrawerActionButton from 'components/menu-drawer/drawer-action-button';
import DrawerContent from 'components/menu-drawer/drawer-content';
import ConfirmUnsavedEditor from 'components/menu-drawer/confirm-unsaved-editor';
import MobileDrawerAppBar from 'components/menu-drawer/mobile/mobile-drawer-app-bar';


const UserPhoto = (props) => {
  const {
    user,
    setUser,
    drawerState,
    onClose
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [photoRef, setPhotoRef] = React.useState();
  const [isDirty, setIsDirty] = React.useState(false);
  const { user: currentUser, setUser: setCurrentUser } = React.useContext(UserContext);
  const title = 'Department Logo';


  const photoChanged = (ref) => {
    if (ref) {
      setIsDirty(true);
      setPhotoRef(ref);
    }
  }


  const savePhoto = async () => {
    if (!photoRef) return;
    
    drawerState.loading.content.set(true);

    try {
      const blob = await new Promise(resolve => 
        photoRef.getImageScaledToCanvas().toBlob(resolve, 'image/png', 1.0));

      let formData = new FormData();
      formData.append('photo', blob);
      const response = await axios.put(`/account/${user.id}/dept-photo`, formData);

      if (response.status === 200) {
        const data = response.data;
        setIsDirty(false);
        setUser(data);
        enqueueSnackbar('Photo Saved', { variant: 'success' });
    
        if (user.id === currentUser.id) {
          setCurrentUser(data);
        }
      }
    } catch (error) {
      enqueueSnackbar('Failed to save photo', { variant: 'error' });
    } finally {
      drawerState.loading.content.set(false);
    }
  }


  const saveButton = (
    <DrawerActionButton
      level={1}
      type="submit"
      disabled={!isDirty}
      onClick={savePhoto}
    >
      Save
    </DrawerActionButton>
  );


  return (
    <>
      <DrawerContentBuilder
        mobileAppBar={{ content: (
          <MobileDrawerAppBar
            title={title}
            saveButton={saveButton}
            onClose={onClose}
          />
        )}}
        desktopHeader={{
          title,
          actions: <>
            <Button upperCase={false} onClick={onClose}>Cancel</Button>
            {saveButton}
          </>
        }}
        children={(
          <DrawerContent>
            <Typography variant='subtext-large'>
              Upload a badge or logo that represents your department. This image will appear at the top of your reports.
            </Typography>
            <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
              <PhotoEditor photo={user?.departmentLogoUrl} onChange={photoChanged} />
            </Box>
          </DrawerContent>
        )}
      />
      
      <ConfirmUnsavedEditor 
        dirty={isDirty} 
        save={savePhoto} 
      />
    </>
  )
}

export default UserPhoto;